import { useMemo } from 'react'

export const useInputErrors = (error: any, label: string = '') => {
  return useMemo(() => {
    if (typeof error === 'string') {
      return error
    }
    if (error?.message) {
      return error?.message
    }
    if (!['pattern', 'maxLength', 'minLength', 'required', 'max'].includes(error?.type)) {
      return error?.type
    }
    switch (error?.type) {
      case 'maxLength':
        return `${label} too long`
      case 'minLength':
        return `${label} too short`
      case 'required':
        return `${label} is required`
      case 'pattern':
        return `Invalid ${label}`
      case 'max':
        return `The Number is larger than maximum value`
    }
  }, [error])
}
